<div (click)="onCheckBoxClicked()" class="checkbox noselect"
     fxLayoutAlign="start center">
    <i class="ju ju-checkbox_unfilled" *ngIf="!inputModel"></i>
    <i class="ju ju-checkbox_filled" *ngIf="inputModel"></i>
    <div><ng-content></ng-content></div>
</div>

